function EventHistoryTableController(analysisService, toasterService, $filter, __env) {
  const ctrl = this;
  const env = __env;

  ctrl.$onInit = () => {
    ctrl.overflow = {};
    ctrl.envColumns = [];
    // TODO: Dynamically add envColumns here for sorting
    ctrl.reversed = {
      CONSIST: true,
      CAR: true,
      EVENT_ID: true,
      ACTIVATED: true,
      TITLE: true,
      PRIORITY: true,
      ACTION: true,
    };
    ctrl.sortType = 'ACTIVATED';
    ctrl.supportsAlarmAnalytics = env.profile === 'LU';
    ctrl.showsActiveCarLabel = env.profile === 'QR';
    ctrl.usesAlternateEventDisplay = env.profile === 'MELCO';
    ctrl.usesQualifierEventColor = env.profile === 'VALE';
    ctrl.trainTranslate = ctrl.showsActiveCarLabel
      ? 'analysis.alarm-analysis-event-history.column-headers.activecar'
      : 'analysis.alarm-analysis-event-history.column-headers.consist';
  };

  ctrl.$onChanges = changes => {
    if (changes.eventHistory || changes.selectedEnvData) {
      ctrl.overflow = {};
      ctrl.envColumns = buildEnvDataColumns(ctrl.eventHistory);
    }
  };

  const buildEnvDataColumns = eventHistory => {
    if (ctrl.supportsAlarmAnalytics) {
      return ctrl.selectedEnvData || [];
    }
    if (!Array.isArray(eventHistory) || eventHistory.length === 0) {
      return [];
    }
    const found = eventHistory.find(item => item?.environmentData && Object.keys(item.environmentData).length > 0);
    return found ? Object.keys(found.environmentData) : [];
  };

  ctrl.toggleOverflow = index => {
    ctrl.overflow[index] = ctrl.overflow[index] ? '' : 'showOverflow';
  };

  ctrl.loadPage = reload => {
    ctrl.loadMore({
      $event: {
        reload: reload,
        sortType: ctrl.sortType,
        reversed: ctrl.reversed[ctrl.sortType],
      },
    });
  };

  ctrl.sortColumn = sortType => {
    if (ctrl.loadBusy) return;
    ctrl.sortType = sortType || null;
    ctrl.reversed[sortType] = !ctrl.reversed[sortType];
    ctrl.loadPage(true);
  };

  ctrl.eventColor = event => {
    if (ctrl.usesQualifierEventColor) {
      return event.qualifier ? event.qualifier : event.priority;
    } else {
      return event.priority;
    }
  };
}

angular
  .module('analysis.module')
  .controller('EventHistoryTableController', EventHistoryTableController);
